import s from './MediumCard.module.sass'

export function CardButton(props: { title: string | JSX.Element; onClick: () => void }) {
	return (
		<button type="button" className={s.ConfirmButton} onClick={props.onClick}>
			{props.title}
		</button>
	)
}
